import React, { useEffect } from 'react';
import useScript, { waitForVar } from '../../hooks/useScript';
import { NEXT_PUBLIC_FACEBOOK_APP_ID } from '../../../lib/env';
import { IOAuthProvider } from './OAuthWrapper';

interface FacebookAppSync extends Window {
  fbAsyncInit: () => void;
  FB: any;
}

declare let window: FacebookAppSync;

const Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="md:mr-1">
    <path
      d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"
      fill="#3b5998"
    />
  </svg>
);

const useFacebookLogin = ({ method, logger, setActive, setError, setResponse }): IOAuthProvider => {
  // on mount load FB
  useEffect(() => {
    window.fbAsyncInit = function () {
      FB.init({
        // eslint-disable-line
        appId: NEXT_PUBLIC_FACEBOOK_APP_ID,
        cookie: true, // enable cookies to allow the server to access the session
        version: 'v6.0',
      });
    };
  }, []);

  const { loaded, ready, failed } = useScript(
    '//connect.facebook.net/en_US/sdk.js',
    waitForVar('FB')
  );

  const handleFBLogin = () => {
    const { FB } = window;
    setActive(true);
    if (FB) {
      FB.login(
        (res) => {
          const login = async () => {
            // eslint-disable-line
            if (res.status === 'connected') {
              setActive(true);
              const facebookToken = res.authResponse.accessToken;

              setResponse({
                method,
                variables: {
                  provider: method.toUpperCase(),
                  token: facebookToken,
                },
              });
            } else {
              setActive(false);
              setError(true);
            }
          };

          login();
        },
        { scope: 'public_profile,email' }
      );
    }
  };
  return {
    trigger: handleFBLogin,

    provider: {
      ready: ready && loaded && !failed,
      failed,
      loading: !loaded || !ready,
      disabled: !loaded || !ready || failed,
    },
    Icon,
  };
};

export default useFacebookLogin;
